import { SalesOrderItemResult } from "./sales-order-item-result";
import { UniqueSequentialNumber } from "./unique-sequential-number";

export class SalesOrderResult {
  private uniqueSequentialNumber: UniqueSequentialNumber;
  private uniqueSequentialNumberCorrelated: UniqueSequentialNumber;
  private transactionDate: Date;
  private networkName: string;
  private networkFiscalNumber: string;
  private salesOrderItemsResultList: SalesOrderItemResult[];
  private salesAction: string;
  private beneficiarySocialNumber: string;

  public getBeneficiarySocialNumber(): string {
    return this.beneficiarySocialNumber;
  }
  public setBeneficiarySocialNumber(value: string): void {
    this.beneficiarySocialNumber = value;
  }
  public getUniqueSequentialNumber(): UniqueSequentialNumber {
    return this.uniqueSequentialNumber;
  }
  public setUniqueSequentialNumber(UniqueSequentialNumber: UniqueSequentialNumber): void {
    this.uniqueSequentialNumber = UniqueSequentialNumber;
  }
  public getUniqueSequentialNumberCorrelated(): UniqueSequentialNumber {
    return this.uniqueSequentialNumberCorrelated;
  }
  public setUniqueSequentialNumberCorrelated(UniqueSequentialNumberCorrelated: UniqueSequentialNumber): void {
    this.uniqueSequentialNumberCorrelated = UniqueSequentialNumberCorrelated;
  }
  setTransactionDate(value: Date): void {
    this.transactionDate = value;
  }
  getTransactionDate(): Date {
    return this.transactionDate;
  }
  getTransactioDateSimple(): string {
    return `${this.transactionDate.getDate()}​/${this.transactionDate.getMonth() + 1}​/${this.transactionDate.getFullYear()}​`;
  }
  getTransactionHour(): string {
    return `${this.transactionDate.getHours()}​:${this.transactionDate.getMinutes()}​:${this.transactionDate.getSeconds()}​`;
  }
  setNetworkName(value: string): void {
    this.networkName = value;
  }
  getNetworkName(): string {
    return this.networkName;
  }
  setNetworkFiscalNumber(value: string): void {
    this.networkFiscalNumber = value;
  }
  getNetworkFiscalNumber(): string {
    return this.networkFiscalNumber;
  }
  setSalesOrderItemResultList(value: SalesOrderItemResult[]): void {
    this.salesOrderItemsResultList = value;
  }
  getSalesOrderItemResultList(): SalesOrderItemResult[] {
    return this.salesOrderItemsResultList;
  }
  getSalesOrderItemListLength(): number {
    return this.salesOrderItemsResultList.length;
  }
  hasAllowedProducts(): boolean {
    return this.salesOrderItemsResultList.some((item) => item.getProductQuantity() > 0);
  }
  setSalesAction(value: string): void {
    this.salesAction = value;
  }
  getSalesAction(): string {
    return this.salesAction;
  }
}
